import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useAppSelector } from 'store/hooks';
import preloaderSvg from 'assets/preloader.svg';
import styles from './loader.module.scss';

const MIN_DISPLAY_TIME = 1000;

interface DgentaWritingLoaderProps {
  width?: number;
  height?: number;
  className?: string;
}

export const DgentaWritingLoader: React.FC<DgentaWritingLoaderProps> = ({
  width = 100,
  height = 42,
  className = '',
}) => {
  return (
    <img
      src={preloaderSvg}
      alt="Dgenta Loader"
      width={width}
      height={height}
      className={`${styles.preloaderImg} ${className}`}
    />
  );
};

export const SuspenseLoader: React.FC = () => {
  return ReactDOM.createPortal(
    <div className={styles.overlay}>
      <div className={styles.loaderContent}>
        <DgentaWritingLoader />
      </div>
    </div>,
    document.body,
  );
};

const Loader: React.FC = () => {
  const { isLoading, isLoadingSmall } = useAppSelector((state) => state.ui);
  const isAny = Boolean(isLoading || isLoadingSmall);

  const [cachedVisible, setCachedVisible] = useState(isAny);

  if (isAny && !cachedVisible) {
    setCachedVisible(true);
  }

  useEffect(() => {
    if (isAny) return;

    const timer = setTimeout(() => {
      setCachedVisible(false);
    }, MIN_DISPLAY_TIME);

    return () => clearTimeout(timer);
  }, [isAny]);

  const isVisible = isAny || cachedVisible;

  if (!isVisible) return null;

  return ReactDOM.createPortal(
    <div className={styles.overlay}>
      <div className={styles.loaderContent}>
        <DgentaWritingLoader />
      </div>
    </div>,
    document.body,
  );
};

export default Loader;
